/**
 * ArticleContent —— 文章内容增强 Unpoly 编译器组件
 *
 * 职责：聚合 Prism（语法高亮）、Table（响应式表格）和 ImageZoom（图片放大）子模块，
 * 统一管理文章内容区域的 DOM 增强。
 */

import { ImageZoom } from "./imageZoom";
import { Prism } from "./prism";
import { Table } from "./table";

export class Content {
  private prism: Prism;
  private imageZoom: ImageZoom;
  private activated = false;

  constructor(private element: HTMLElement) {
    this.prism = new Prism(element);
    new Table(element);
    this.imageZoom = new ImageZoom(element);
    this.loadArticleStyles();
    this.initInteraction();
  }

  private loadArticleStyles(): void {
    import("@/article.css").catch((err) => {
      console.warn("[Content] Failed to load article.css:", err);
    });
  }

  private initInteraction(): void {
    // 监听首次滚动或触摸，确保只有用户开始交互后才加载资源
    window.addEventListener("scroll", this.activate, {
      once: true,
      passive: true,
    });
    window.addEventListener("touchstart", this.activate, {
      once: true,
      passive: true,
    });
  }

  /**
   * 当文章内容进入视口时执行激活逻辑
   */
  private activate = (): void => {
    if (this.activated) return;
    this.activated = true;

    console.log(
      "[Content] User interaction detected. Activating enhancements...",
    );

    // 1. 检查是否存在 Ghost 卡片元素，按需加载 CSS
    if (this.element.querySelector('[class*="kg-"]')) {
      import("@/styles/card.css").catch((err) => {
        console.warn("[Content] Failed to load card.css:", err);
      });
    }

    // 2. 通知所有子组件内容已可见
    // 使用 Unpoly 的事件机制通知
    up.emit(this.element, "article:content:visible");
  };

  destroy(): void {
    this.prism.destroy();
    this.imageZoom.destroy();
  }

  /** 注册 Unpoly 编译器 */
  static compiler(selector: string): void {
    up.compiler(selector, (element: Element) => {
      const content = new Content(element as HTMLElement);
      return () => content.destroy();
    });
  }
}
